import styled from "styled-components"

import Heading from "./Heading"

const H5 = styled.h5`
  ${Heading}

  font-size: 26px;
`

export default H5
